import { useRouteError } from 'react-router';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
export function RootErrorBoundary() {
  const error = useRouteError() as Error;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <WarningAmberIcon color="warning" fontSize="large" />
      <Typography variant="body1">An error has occured</Typography>
    </Box>
  );
}
